import WeatherDetailLeftPanel from './WeatherDetailLeftPanel';
import WeatherDetailRightPanel from './WeatherDetailRightPanel';

export default {
  LeftPanel: WeatherDetailLeftPanel,
  RightPanel: WeatherDetailRightPanel,
};



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/SearchInput/LocationTimeAndWeather/WeatherDetail/index.js